import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
} from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';
// import * as actions from '../../redux/actions';
import { ViewTitle } from '../../components/ViewTitle';
import { useDispatch } from 'react-redux';
import * as actions from '../../redux/actions';

function HistoryGold({ title, subtitle }) {
  const dispatch = useDispatch();
  const logTransaction = useSelector((state) => state.logtransaction);
  const [searchTerm, setSearchTerm] = useState('');
  // const [name, setName] = useState('');
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(5);
  const [total, setTotal] = useState(undefined);
  useEffect(() => {
    dispatch(actions.logTransactionAll({ name: '', size: '' }));
    return () => {};
  }, [name, page, size]);

  useEffect(() => {
    setTotal(logTransaction?.total);
    return () => {};
  }, [logTransaction]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      // setName(searchTerm);
      setPage(1);
    }, 700);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const handleChangeRowsPerPage = (event) => {
    setSize(event.target.value);
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
  };

  const renderTable = () => (
    <div className="my-2">
      <Paper>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell>
                  <div className="font-bold">ลำดับที่</div>
                </TableCell>

                <TableCell>
                  <div className="font-bold"> วันที่</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold">รายการ</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold">น้ำหนักรวม</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold"> คลัง</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold">น้ำหนักก่อนหน้า</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold"> น้ำหนักคงเหลือ</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold"> สถานะ</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold"> ผู้ดำเนินการ</div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!_.isEmpty(logTransaction.rows) ? (
                logTransaction.rows.map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {(page - 1) * size + index + 1}
                    </TableCell>
                    <TableCell>
                      {new Date(row?.date).toLocaleDateString('th', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                      })}
                    </TableCell>
                    <TableCell>{`${row?.product?.name}(${row?.product_type?.name})`}</TableCell>
                    <TableCell>{`${row?.weight.toFixed(2)}`}</TableCell>
                    <TableCell>{`${row?.place_name || '-'}`}</TableCell>
                    <TableCell>{(row?.prev_weight || 0).toFixed(3)}</TableCell>
                    <TableCell>{(row?.next_weight || 0).toFixed(3)}</TableCell>
                    <TableCell>{row?.gold_transaction_type || 0}</TableCell>
                    <TableCell>{`${row?.user?.firstname}  ${row?.user?.lastname}`}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6}>
                    <div className="text-center">ไม่มีข้อมูล</div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          rowsPerPageOptions={[]}
          onRowsPerPageChange={handleChangeRowsPerPage}
          page={page - 1}
          count={total || 1}
          rowsPerPage={size}
          onPageChange={handleChangePage}
        />
      </Paper>
    </div>
  );

  return (
    <div>
      <div className="flex justify-between">
        <div>{renderTitle()}</div>
      </div>{' '}
      {/* {renderSearch()} */}
      {renderTable()}
    </div>
  );
}

export default HistoryGold;
